// extracted by css-extract-rspack-plugin
export default {"iframe":"FGaZgpgo","hidden":"gwpmQBWQ"};